import { render, staticRenderFns } from "./SocialAdDemographics.vue?vue&type=template&id=0427d6ac&scoped=true&"
import script from "./SocialAdDemographics.vue?vue&type=script&lang=ts&"
export * from "./SocialAdDemographics.vue?vue&type=script&lang=ts&"
import style0 from "./SocialAdDemographics.vue?vue&type=style&index=0&id=0427d6ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427d6ac",
  null
  
)

export default component.exports